// see https://stackoverflow.com/questions/47706903/add-a-class-to-the-html-body-tag-with-react
// react core
import React from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Outlet } from 'react-router-dom';

// notification
import 'react-notifications/lib/notifications.css';
import { NotificationContainer } from 'react-notifications';

const add_bodyclass = className => document.body.classList.add(className);
const remove_body_class = className => document.body.classList.remove(className);
const normalize = str =>
{
    // cleaning first and last //
    let s = str.replace(/^\/+/g,'').replace(/\/+$/g,'');
    return s.replaceAll('/', '_');
}

export default function SiteRoot(props)
{
    const location = useLocation();

    useEffect(
    () =>
        {
            let loc_string = normalize(location.pathname);
            console.log("path name is => " + location.pathname);
            // hack for having login route on root
            loc_string = (loc_string === 'auth') ? 'auth_login' : loc_string;
            if(!document.body.classList.contains(loc_string))
            {
                add_bodyclass(loc_string);
            }
            // Clean up
            return () =>
            {
                remove_body_class(loc_string);
            };
        },
        [location]
    );


    return (
        <>
            <NotificationContainer />
            <Outlet />
        </>
    );
};

